module.exports = __webpack_public_path__ + "img/collapse.83311c3c.svg";